import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-cream-100 py-16 sm:py-20" aria-labelledby="results-title" data-id="element-152" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-153" data-mp="28ddg15bty3om">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-154" data-mp="2d6zu91xn6fmj">
          Lo que dicen los docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-155" data-mp="2m5tpanvbqxxz">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-earth-200 bg-white p-6 shadow-sm shadow-earth-900/5 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-156" data-mp="2r68z55gednb7" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-gold-500" aria-hidden="true" data-id="element-157" data-mp="3imzefdvq54bj" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-earth-900" data-id="element-158" data-mp="3ikwk4hnjgp10">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-earth-100 pt-4" data-id="element-159" data-mp="38otgf7d1giby">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-forest-800 text-sm font-extrabold text-gold-300" data-id="element-160" data-mp="a6w7598ixhnq">
                  {initials}
                </span>
                <span data-id="element-161" data-mp="8q76x6a2lli">
                  <b className="block text-sm text-forest-950" data-id="element-162" data-mp="7youo1oykd6">{name}</b>
                  <small className="text-xs text-earth-500" data-id="element-163" data-mp="3scj0eseqheam">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}